<template>
	<div
		class="selection-status"
		data-test="selection-status"
		v-if="showSelectionStatus"
	>
		<font-awesome-icon
			class="exclamation-icon"
			:icon="['fal', 'exclamation-circle']"
		/>
		{{ selectionStatusMessage }}
		<TextButton
			class="select-button"
			@onClick="handleSelectMode"
		>
			{{ selectAllButtonMessage }}
		</TextButton>
	</div>
</template>

<script>
import TextButton from '@/components/global/TextButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
	name: 'SelectionStatus',
	components: {
		TextButton,
		FontAwesomeIcon,
	},
	props: {
		selectAllMode: Boolean,
		leadIdsCount: Number,
		totalCount: Number,
	},
	computed: {
		selectionStatusMessage() {
			return `${this.firstWord}${this.totalSelectedContacts} contact${this.plural} selected`;
		},
		firstWord() {
			return this.selectAllMode && this.leadIdsCount === 0 ? 'All ' : '';
		},
		plural() {
			if (!this.selectAllMode) return this.leadIdsCount > 1 ? 's' : '';
			// when selectAllMode is true and all but 1 contact is unselected
			return this.leadIdsCount === this.totalCount - 1 ? '' : 's';
		},
		selectAllButtonMessage() {
			if (this.selectAllMode) return 'Unselect all';
			return `Select all ${this.totalCount} contacts in your contacts.`;
		},
		showSelectionStatus() {
			return this.leadIdsCount > 0 || this.selectAllMode;
		},
		totalSelectedContacts() {
			if (!this.selectAllMode) return this.leadIdsCount;
			return this.totalCount - this.leadIdsCount;
		},
	},
	methods: {
		handleSelectMode() {
			this.$emit('updateSelectAllMode', !this.selectAllMode);
		},
	},
};
</script>

<style lang="scss" scoped>
.selection-status {
	display: inline-flex;
	flex-wrap: wrap;
	text-align: center;
	justify-content: center;
	align-items: flex-end;
	width: 100%;
	@include rem('margin-top', 15px);
	.exclamation-icon,
	.select-button {
		padding: 0 0.5rem;
	}

	.exclamation-icon {
		color: $brand-blue;
		font-weight: 200;
		@include rem('font-size', 20px);
	}

	.select-button {
		display: inline;
		text-align: center;
	}
}
</style>
